import { Icon } from '@repo/ui';

import { Badge } from 'components/Badge';
import { useTinyPlusNavState } from 'hooks/useTinyPlusNavState';

import styles from './TinyPlusNav.module.css';

export const TinyPlusMemberBadge = () => {
  const { showMemberBadge } = useTinyPlusNavState();
  if (!showMemberBadge) return null;
  return (
    <div className={styles.badgeContainer}>
      <Badge
        state='tinyPlus'
        size='sm'
        testId='tiny-plus-member-badge'
        className={styles.memberBadge}
        title={
          <span className={styles.memberBadgeTitle}>
            <Icon name='awardFilled' size='s' />
            Tiny+ Member
          </span>
        }
      />
    </div>
  );
};

export default TinyPlusMemberBadge;
